import apiRequest from './apiRequest';

// <======================= Workflow Template APIs =======================>
const createWorkflowTemplate = (data, token) => {
    const url = `/api/v1/template/workflows/templates`;
    return apiRequest(url, 'POST', token, data);
};
const createTemplate = (data, token) => {
    const url = `/api/v1/template/workflows`;
    return apiRequest(url, 'POST', token, data);
};
const updateTemplate = (id, token) => {
    const url = `/api/v1/template/workflows/update/${id}`;
    return apiRequest(url, 'PUT', token);
};

const getAllWorkflowTemplates = (token) => {
    const url = `/api/v1/template/workflows/templates`;
    return apiRequest(url, 'GET', token);
};

const instantiateWorkflow = (templateId, data, token) => {
    const url = `/api/v1/template/workflows/instantiate/${templateId}`;
    return apiRequest(url, 'POST', token, data);
};

const getWorkflowById = (workflowId, token) => {
    const url = `/api/v1/template/workflows/${workflowId}`;
    return apiRequest(url, 'GET', token);
};

const createTemplateTasks = (workflowId, data, token) => {
    const url = `/api/v1/template/workflows/${workflowId}/tasks`;

    return apiRequest(url, 'POST', token, data);
};

const updateTemplateTasks = (workflowId, tasksId,token, data) => {
    const url = `/api/v1/template/workflows/${workflowId}/tasks/${tasksId}`;
    return apiRequest(url, 'PUT', token, data);
};


const removeTemplateTasks = (workflowId, data, token, taskId) => {
    const url = `/api/v1/template/workflows/${workflowId}/tasks/${taskId}`;
    return apiRequest(url, 'DELETE', token, data);
};
const deleteWorkflowTemplate = (id, token) => {
    const url = `/api/v1/template/workflows/${id}`;
    return apiRequest(url, 'DELETE', token);
};

 const  addTaskToTemplateWorkflow = (templateId, taskData, token)=> {
        return apiRequest(`/api/template/workflows/${templateId}/tasks`, 'POST', token, taskData);
    };

  const updateWorkflowTaskTemplate = (templateId, taskId, taskData, token)=> {
        return apiRequest(`/api/v1/template/workflows/${templateId}/tasks/${taskId}`, 'PUT', token, taskData);
    };

   const deleteTaskTemplate = (templateId, taskId, token) =>{
        return apiRequest(`/api/v1/template/workflows/${templateId}/tasks/${taskId}`, 'DELETE', token);
    };

// <======================= Workflow APIs =======================>
const createWorkflow = (data, token) => {
    const url = `/api/v1/workflows`;
    return apiRequest(url, 'POST', token, data);
};

const updateWorkflow = (workflowId, data, token) => {
    const url = `/api/v1/workflows/${workflowId}`;
    return apiRequest(url, 'PUT', token, data);
};

const WorkflowById = (workflowId, data, token) => {
    const url = `/api/v1/workflows/${workflowId}`;
    return apiRequest(url, 'GET', token, data);
};
const WorkflowByAccountId = (accountId, token) => {
    const url = `/api/v1/workflows/byAccount/${accountId}`;
    return apiRequest(url, 'GET', token);
};

const deleteWorkflow = (workflowId, token, data) => {
    const url = `/api/v1/workflows/${workflowId}`;
    return apiRequest(url, 'DELETE', token, data);
};

const deleteWorkflowNew = (workflowId, token) => {
    const url = `/api/v1/workflows/${workflowId}`;
    return apiRequest(url, 'DELETE', token);
};

const getTasksForWorkflow = (workflowId, data, token) => {
    const url = `/api/v1/workflows/${workflowId}/tasks`;
    return apiRequest(url, 'GET', token, data);
};
const addTasksForWorkflow = (workflowId, data, token) => {
    const url = `/api/v1/workflows/${workflowId}/tasks`;
    return apiRequest(url, 'POST', token, data);
};


const removeTasksFromWorkflow = (workflowId, taskId, token) => {
    const url = `/api/v1/workflows/${workflowId}/tasks/${taskId}`;
    return apiRequest(url, 'DELETE', token);
};


const allWorkflow = (data, token) => {
    const url = `/api/v1/workflows`;
    return apiRequest(url, 'GET', token, data);
};

const searchWorkflow = (keyword, token) => {
    const url = `/api/v1/workflows/search/${keyword}`;
    return apiRequest(url, 'GET', token);
};

const workflowApi = {
    createWorkflowTemplate,
    getAllWorkflowTemplates,
    instantiateWorkflow,
    getWorkflowById,
    createWorkflow,
    deleteWorkflowNew,
    allWorkflow,
    updateWorkflow,
    WorkflowById,
    deleteWorkflow,
    getTasksForWorkflow,
    addTasksForWorkflow,
    removeTasksFromWorkflow,
    updateTemplateTasks,
    removeTemplateTasks,
    createTemplateTasks,
    deleteWorkflowTemplate,
    addTaskToTemplateWorkflow,
    updateWorkflowTaskTemplate,
    deleteTaskTemplate,
    createTemplate,
    updateTemplate,
    WorkflowByAccountId,
    searchWorkflow
    
};

export default workflowApi;
